export const STATEMENTS = Object.freeze({
  iedereen_mee: {
    order: 1,
  },
  digitaal_eerlijk: {
    order: 2,
  },
  persoonsgegevens: {
    order: 3,
  },
  medewerker: {
    order: 4,
  },
  oplichting: {
    order: 5,
  },
});

export const STATEMENT_KEYS = Object.entries(STATEMENTS)
  .sort(([, v1], [, v2]) => v1.order - v2.order)
  .map(([k]) => k);
